import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { LoginContext } from '../../../context/LoginContext';
import { Link, useParams } from 'react-router-dom';

const PhonePePayment = () => {
  const { userId } = useContext(LoginContext);
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const param = useParams();

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      setLoading(true);
      try {
        const merchantOrderId = param.id;
        const response = await axios.get(
          `${process.env.REACT_APP_API_PAYMENT_URL}phonepe/callback?merchantOrderId=${merchantOrderId}`
        );
        setPaymentData(response.data);
      } catch (error) {
        console.error('Error fetching payment status:', error);
        setPaymentData(null);
      } finally {
        setLoading(false);
      }
    };

    if (param.id) {
      fetchPaymentStatus();
    } else {
      setLoading(false);
    }
  }, [param.id]);

  const state = paymentData?.status?.state;
  const isCompleted = state === 'COMPLETED';
  const isFailed = state === 'FAILED' || !state;
  const details = paymentData?.status?.paymentDetails?.[0];
  const orderId = paymentData?.status?.orderId || param.id || '—';
  const paymentMode = isCompleted
    ? (details?.paymentMode || '—')
    : (paymentData?.status?.errorCode || 'TXN_CANCELLED');
  const amountPaise = isCompleted
    ? details?.amount
    : paymentData?.status?.amount;
  const amount = amountPaise != null ? amountPaise / 100 : '—';

  return (
    <div className="payment-status-page">
      <div className="container py-4 px-3 px-md-4">
        <h4 className="text-center fw-bold mb-3">Payment Status</h4>

        {loading && (
          <p className="text-center text-muted py-5">Loading payment details…</p>
        )}

        {!loading && (
          <>
            <div
              className={`payment-status-banner mb-4 ${isCompleted ? 'is-success' : 'is-failed'}`}
            >
              <p className="payment-status-label mb-1">
                {isCompleted ? 'Payment successful' : 'Payment not completed'}
              </p>
              <p className="payment-status-hint mb-0">
                {isCompleted
                  ? 'Your Premium plan is now active. Enjoy Hindu Sanjog!'
                  : 'Transaction was cancelled or failed. You can try again anytime.'}
              </p>
            </div>

            <div className="payment-detail-cards payment-detail-cards--mobile">
              <div className="payment-detail-item">
                <span className="payment-detail-key">Order ID</span>
                <span className="payment-detail-val">{orderId}</span>
              </div>
              <div className="payment-detail-item">
                <span className="payment-detail-key">Payment mode</span>
                <span className="payment-detail-val">{paymentMode}</span>
              </div>
              <div className="payment-detail-item">
                <span className="payment-detail-key">Amount</span>
                <span className="payment-detail-val">{amount !== '—' ? `₹ ${amount}` : '—'}</span>
              </div>
              <div className="payment-detail-item">
                <span className="payment-detail-key">Status</span>
                <span className="payment-detail-val">
                  {isCompleted ? (
                    <span className="badge bg-success">Success</span>
                  ) : (
                    <span className="badge bg-danger">Failed</span>
                  )}
                </span>
              </div>
            </div>

            <div className="payment-status-table-wrap mt-4">
              <div className="card border-0 shadow-sm">
                <div className="table-responsive payment-status-table-scroll">
                  <table className="table table-bordered mb-0 payment-status-table">
                    <thead>
                      <tr>
                        <th>Order Id</th>
                        <th>Payment Mode</th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-label="Order Id" className="text-break">{orderId}</td>
                        <td data-label="Payment Mode">{paymentMode}</td>
                        <td data-label="Amount">{amount !== '—' ? `₹ ${amount}` : '—'}</td>
                        <td data-label="Status">
                          {isCompleted ? (
                            <span className="badge bg-success">Success</span>
                          ) : (
                            <span className="badge bg-danger">Failed</span>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="payment-status-actions mt-4">
              <Link to="/recently-joined-matches" className="btn btn-outline-danger">
                Back to matches
              </Link>
              {isFailed && userId && (
                <Link to={`/upgrade/${userId}`} className="btn btn-danger">
                  Try payment again
                </Link>
              )}
              {isCompleted && userId && (
                <Link to={`/plan/${userId}`} className="btn btn-danger">
                  View active plan
                </Link>
              )}
            </div>
          </>
        )}
      </div>

      <style>{`
        .payment-status-page {
          width: 100%;
          overflow-x: hidden;
        }
        .payment-status-banner {
          border-radius: 12px;
          padding: 16px 18px;
          text-align: center;
        }
        .payment-status-banner.is-success {
          background: #e8f5e9;
          border: 1px solid #a5d6a7;
        }
        .payment-status-banner.is-failed {
          background: #ffebee;
          border: 1px solid #ef9a9a;
        }
        .payment-status-label {
          font-weight: 700;
          font-size: 1.1rem;
        }
        .payment-status-hint {
          font-size: 14px;
          color: #444;
        }
        .payment-detail-cards {
          display: none;
          grid-template-columns: 1fr;
          gap: 10px;
        }
        .payment-status-table-wrap {
          display: block;
        }
        @media (max-width: 767.98px) {
          .payment-status-page {
            overflow-x: hidden;
          }
          .payment-detail-cards--mobile {
            display: grid !important;
          }
          .payment-status-table-wrap {
            display: none !important;
          }
        }
        @media (min-width: 768px) {
          .payment-detail-cards--mobile {
            display: none !important;
          }
          .payment-status-table-wrap {
            display: block !important;
          }
          .payment-status-table-scroll {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }
          .payment-status-table th,
          .payment-status-table td {
            white-space: nowrap;
          }
          .payment-status-table td:first-child {
            white-space: normal;
            min-width: 220px;
            max-width: 320px;
          }
        }
        @media (min-width: 576px) and (max-width: 767.98px) {
          .payment-detail-cards--mobile {
            grid-template-columns: 1fr 1fr;
          }
        }
        .payment-detail-item {
          background: #fff;
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 12px 14px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.04);
        }
        .payment-detail-key {
          display: block;
          font-size: 12px;
          color: #888;
          text-transform: uppercase;
          letter-spacing: 0.02em;
          margin-bottom: 6px;
        }
        .payment-detail-val {
          display: block;
          font-size: 14px;
          font-weight: 600;
          word-break: break-word;
          overflow-wrap: anywhere;
        }
        .payment-status-actions {
          display: flex;
          flex-direction: column;
          gap: 10px;
          align-items: stretch;
        }
        @media (min-width: 576px) {
          .payment-status-actions {
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;
          }
          .payment-status-actions .btn {
            min-width: 180px;
          }
        }
      `}</style>
    </div>
  );
};

export default PhonePePayment;
